import {useEffect} from 'react';
import {useRouteError} from 'react-router-dom';
import {isError} from 'lodash';

import {showUpdateNotification} from 'utils/appVersionUtils';
import {isWebViewApp} from 'core/utils/webView';
import {NoPermissionError, NotFoundError} from 'core/utils/errors';
import {EnnablLogger} from 'utils/ennabl';

import {SomethingWentWrongPage} from 'components/errors/SomethingWentWrongPage';
import {NoPermissionPage} from 'components/errors/NoPermissionPage';
import NotFoundPage from 'components/errors/NotFoundPage';

export const RouterErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (!isError(error)) {
      return;
    }

    if (!(error instanceof NotFoundError)) {
      EnnablLogger.captureException(error);
    }

    if (isWebViewApp()) {
      console.error(error);
    }

    if ('ChunkLoadError' === error?.name) {
      showUpdateNotification(true);
    }
  }, [error]);

  if (error instanceof NoPermissionError) {
    return <NoPermissionPage />;
  }

  if (error instanceof NotFoundError) {
    return <NotFoundPage />;
  }

  return <SomethingWentWrongPage />;
};
